import moment from 'moment';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { validateForm, onChange, isValidDate } from '../../../utils';
import { getWeightage, } from '../../../action/admin/weightage';
import { getAppraisalCycle } from '../../../action/Master';
import CONSTANT from '../../../constant';

class EmployeeList extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            appraisalList: [{ code: '12mn2xsdf', yearCycle: '--Select--' }],
            performancelList: [{ code: '12mn2xsdf', startDate: '--Select--' }],
            weightageList: undefined,
            yearCycle: { name: 'yearCycle', value: '', error: '', isRequired: true },
            monthCycle: { name: 'monthCycle', value: '', error: '', isRequired: true }

        }


    }

    componentDidMount() {
        // this.laodAppraisalList();
        this.loadweightageList()
    }

    public render() {

        const { monthCycle, yearCycle, performancelList, appraisalList, weightageList } = this.state;

        return (
            <React.Fragment>
                <section>
                    <div className="col-lg-12 main-container">
                        <div className="fluid-container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="col-lg-12 mt-4">
                                        <div className="row">
                                            <div className="col-6 col-lg-6 pl-0">
                                                <h5 className="heading-h1">Weightage List</h5>
                                            </div>

                                            <div className="col-6 col-lg-6 text-right pr-0">
                                                <Link to={CONSTANT.url.addWeightage} className="action-btn">
                                                    <i
                                                        className="fa fa-check-square-o"></i>&nbsp; Add Weightage</Link>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="card mt-2">
                                        <div className="card-header">
                                            <b>Appraisal
                                           </b>
                                        </div>
                                        <div className="card-body">

                                            {
                                                <form>
                                                    <div className="col-lg-12 mb-2">
                                                        <div className="row">
                                                            <div className="col-lg-6 form-group">
                                                                <label > Appraisal Cycle  </label>
                                                                {this.renderSelect(yearCycle, appraisalList, 'appraisal')}
                                                            </div>
                                                            <div className="col-lg-6 form-group">
                                                                <label >Sub Performance </label>
                                                                {this.renderSelect(monthCycle, performancelList, 'preformance')}
                                                            </div>
                                                        </div>
                                                        <a href="all-employee.html" className="col-lg-2 pull-right">
                                                            <button onClick={this.loadWList} className="btn button-full action-btn">Filter</button>

                                                        </a>
                                                    </div>
                                                </form>
                                            }
                                        </div>

                                    </div> */}
                                    <div className="card mt-3">
                                        <div className="card-header">
                                            <b>Employee
                                           </b>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Designation </th>
                                                            <th scope="col">Department </th>
                                                            <th scope="col">Activities </th>
                                                            <th scope="col">Behaviour </th>
                                                            <th scope="col">Max Activities </th>
                                                            <th scope="col">Max Department </th>
                                                            <th scope="col">Max Behaviour </th>
                                                            <th scope="col">Month Cycle </th>
                                                            <th scope="col">Year Cycle </th>
                                                            <th scope="col">Create Date</th>
                                                            <th scope="col">Edit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            weightageList === undefined && <tr>
                                                                <td className="text-center" colSpan={11}>Loading...</td>
                                                            </tr>
                                                        }
                                                        {
                                                            weightageList !== undefined && weightageList.length === 0 && <tr>
                                                                <td className="text-center" colSpan={11}>No records found</td>
                                                            </tr>
                                                        }
                                                        {
                                                            weightageList !== undefined &&
                                                            weightageList.map((item: any, ind: number) => {
                                                                return (
                                                                    <tr key={ind}>
                                                                        <td>{item.designation}</td>
                                                                        <td>{item.department}</td>
                                                                        <td>{item.activities}</td>
                                                                        <td>{item.behaviour}</td>
                                                                        <td>{item.maxActivities}</td>
                                                                        <td>{item.maxDepartment}</td>
                                                                        <td>{item.maxBehaviour}</td>
                                                                        <td>{item.monthCycle.length ? item.monthCycle[0].startDate : moment().format('YYYY-MM-DD')}</td>
                                                                        <td>{item.yearCycle[0].yearCycle}</td>
                                                                        <td>{moment.unix(item.createdOn).format('MMM Do YYYY')}</td>
                                                                        <th scope="col">
                                                                            <Link to={CONSTANT.url.editWeightage.replace(':code', item.code)}> <i className="fa fa-pencil"></i> </Link>

                                                                        </th>
                                                                    </tr>
                                                                )
                                                            })
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </React.Fragment>

        )
    }




    private loadweightageList = () => {
        getWeightage().then((response: any) => {
            if (response && response.result && response.result.length)
                this.setState({
                    weightageList: response.result,
                });

        });
    }

}

export default EmployeeList;